import imgZero from './images/printing/img_0.png';
import imgOne from './images/printing/img_1.png';

export default {
  v: '5.5.8',
  fr: 29.9700012207031,
  ip: 0,
  op: 206.000008390552,
  w: 1080,
  h: 1080,
  nm: 'Printing - Feathered',
  ddd: 1,
  assets: [
    {
      id: 'image_0',
      w: 1489,
      h: 2537,
      u: '',
      p: imgZero,
      e: 0
    },
    {
      id: 'image_1',
      w: 463,
      h: 195,
      u: '',
      p: imgOne,
      e: 0
    },
    {
      id: 'comp_0',
      layers: [
        {
          ddd: 0,
          ind: 1,
          ty: 4,
          nm: 'Shape Layer 3',
          sr: 1,
          ks: {
            o: {
              a: 0,
              k: 100,
              ix: 11
            },
            r: {
              a: 0,
              k: 0,
              ix: 10
            },
            p: {
              a: 0,
              k: [168, 77, 0],
              ix: 2
            },
            a: {
              a: 0,
              k: [100, -50, 0],
              ix: 1
            },
            s: {
              a: 1,
              k: [
                {
                  i: {
                    x: [0.833, 0.833, 0.833],
                    y: [0.833, 0.833, 0.833]
                  },
                  o: {
                    x: [0.167, 0.167, 0.167],
                    y: [0.167, 0.167, 0.167]
                  },
                  t: 0,
                  s: [75, 75, 100]
                },
                {
                  t: 38.0000015477717,
                  s: [100, 100, 100]
                }
              ],
              ix: 6,
              x:
                "var $bm_rt;\nvar amp, freq, decay, n, t, v;\ntry {\n    amp = $bm_div(effect('Scale - Overshoot')('ADBE Slider Control-0001'), 2.5), freq = $bm_div(effect('Scale - Bounce')('ADBE Slider Control-0001'), 20), decay = $bm_div(effect('Scale - Friction')('ADBE Slider Control-0001'), 20), n = 0, 0 < numKeys && (n = nearestKey(time).index, key(n).time > time && n--), t = 0 === n ? 0 : $bm_sub(time, key(n).time), $bm_rt = 0 < n ? (v = velocityAtTime($bm_sub(key(n).time, $bm_div(thisComp.frameDuration, 10))), $bm_sum(value, $bm_div($bm_mul($bm_mul($bm_div(v, 100), amp), Math.sin($bm_mul($bm_mul($bm_mul(freq, t), 2), Math.PI))), Math.exp($bm_mul(decay, t))))) : value;\n} catch (e$$4) {\n    $bm_rt = value = value;\n}"
            }
          },
          ao: 0,
          ef: [
            {
              ty: 5,
              nm: 'Linear Wipe',
              np: 5,
              mn: 'ADBE Linear Wipe',
              ix: 1,
              en: 1,
              ef: [
                {
                  ty: 0,
                  nm: 'Transition Completion',
                  mn: 'ADBE Linear Wipe-0001',
                  ix: 1,
                  v: {
                    a: 1,
                    k: [
                      {
                        i: {
                          x: [0.833],
                          y: [0.833]
                        },
                        o: {
                          x: [0.167],
                          y: [0.167]
                        },
                        t: 0,
                        s: [100]
                      },
                      {
                        t: 50.0000020365418,
                        s: [0]
                      }
                    ],
                    ix: 1
                  }
                },
                {
                  ty: 0,
                  nm: 'Wipe Angle',
                  mn: 'ADBE Linear Wipe-0002',
                  ix: 2,
                  v: {
                    a: 0,
                    k: 182,
                    ix: 2
                  }
                },
                {
                  ty: 0,
                  nm: 'Feather',
                  mn: 'ADBE Linear Wipe-0003',
                  ix: 3,
                  v: {
                    a: 0,
                    k: 28,
                    ix: 3
                  }
                }
              ]
            },
            {
              ty: 5,
              nm: 'Scale - Overshoot',
              np: 3,
              mn: 'ADBE Slider Control',
              ix: 2,
              en: 1,
              ef: [
                {
                  ty: 0,
                  nm: 'Slider',
                  mn: 'ADBE Slider Control-0001',
                  ix: 1,
                  v: {
                    a: 0,
                    k: 20,
                    ix: 1,
                    x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
                  }
                }
              ]
            },
            {
              ty: 5,
              nm: 'Scale - Bounce',
              np: 3,
              mn: 'ADBE Slider Control',
              ix: 3,
              en: 1,
              ef: [
                {
                  ty: 0,
                  nm: 'Slider',
                  mn: 'ADBE Slider Control-0001',
                  ix: 1,
                  v: {
                    a: 0,
                    k: 40,
                    ix: 1,
                    x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
                  }
                }
              ]
            },
            {
              ty: 5,
              nm: 'Scale - Friction',
              np: 3,
              mn: 'ADBE Slider Control',
              ix: 4,
              en: 1,
              ef: [
                {
                  ty: 0,
                  nm: 'Slider',
                  mn: 'ADBE Slider Control-0001',
                  ix: 1,
                  v: {
                    a: 0,
                    k: 40,
                    ix: 1,
                    x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
                  }
                }
              ]
            }
          ],
          shapes: [
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [[0, 0], [0, 0]],
                      o: [[0, 0], [0, 0]],
                      v: [[94.944, -15.174], [105.056, -84.826]],
                      c: false
                    },
                    ix: 2
                  },
                  nm: 'Path 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false
                },
                {
                  ty: 'st',
                  c: {
                    a: 0,
                    k: [0, 0, 0, 1],
                    ix: 3
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 4
                  },
                  w: {
                    a: 0,
                    k: 6,
                    ix: 5
                  },
                  lc: 2,
                  lj: 1,
                  ml: 4,
                  bm: 0,
                  nm: 'Stroke 1',
                  mn: 'ADBE Vector Graphic - Stroke',
                  hd: false
                },
                {
                  ty: 'tr',
                  p: {
                    a: 0,
                    k: [0, 0],
                    ix: 2
                  },
                  a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                  },
                  s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                  },
                  r: {
                    a: 0,
                    k: 0,
                    ix: 6
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 7
                  },
                  sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                  },
                  sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                  },
                  nm: 'Transform'
                }
              ],
              nm: 'Shape 1',
              np: 3,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: 'ADBE Vector Group',
              hd: false
            }
          ],
          ip: 0,
          op: 420.000017106951,
          st: 0,
          bm: 0
        },
        {
          ddd: 0,
          ind: 2,
          ty: 4,
          nm: 'Shape Layer 2',
          sr: 1,
          ks: {
            o: {
              a: 0,
              k: 100,
              ix: 11
            },
            r: {
              a: 0,
              k: 0,
              ix: 10
            },
            p: {
              a: 0,
              k: [106.5, 84, 0],
              ix: 2
            },
            a: {
              a: 0,
              k: [0, 0, 0],
              ix: 1
            },
            s: {
              a: 1,
              k: [
                {
                  i: {
                    x: [0.833, 0.833, 0.833],
                    y: [0.833, 0.833, 0.833]
                  },
                  o: {
                    x: [0.167, 0.167, 0.167],
                    y: [0.167, 0.167, 0.167]
                  },
                  t: 0,
                  s: [75, 75, 100]
                },
                {
                  t: 38.0000015477717,
                  s: [100, 100, 100]
                }
              ],
              ix: 6,
              x:
                "var $bm_rt;\nvar amp, freq, decay, n, t, v;\ntry {\n    amp = $bm_div(effect('Scale - Overshoot')('ADBE Slider Control-0001'), 2.5), freq = $bm_div(effect('Scale - Bounce')('ADBE Slider Control-0001'), 20), decay = $bm_div(effect('Scale - Friction')('ADBE Slider Control-0001'), 20), n = 0, 0 < numKeys && (n = nearestKey(time).index, key(n).time > time && n--), t = 0 === n ? 0 : $bm_sub(time, key(n).time), $bm_rt = 0 < n ? (v = velocityAtTime($bm_sub(key(n).time, $bm_div(thisComp.frameDuration, 10))), $bm_sum(value, $bm_div($bm_mul($bm_mul($bm_div(v, 100), amp), Math.sin($bm_mul($bm_mul($bm_mul(freq, t), 2), Math.PI))), Math.exp($bm_mul(decay, t))))) : value;\n} catch (e$$4) {\n    $bm_rt = value = value;\n}"
            }
          },
          ao: 0,
          ef: [
            {
              ty: 5,
              nm: 'Linear Wipe',
              np: 5,
              mn: 'ADBE Linear Wipe',
              ix: 1,
              en: 1,
              ef: [
                {
                  ty: 0,
                  nm: 'Transition Completion',
                  mn: 'ADBE Linear Wipe-0001',
                  ix: 1,
                  v: {
                    a: 1,
                    k: [
                      {
                        i: {
                          x: [0.833],
                          y: [0.833]
                        },
                        o: {
                          x: [0.167],
                          y: [0.167]
                        },
                        t: 0,
                        s: [100]
                      },
                      {
                        t: 50.0000020365418,
                        s: [0]
                      }
                    ],
                    ix: 1
                  }
                },
                {
                  ty: 0,
                  nm: 'Wipe Angle',
                  mn: 'ADBE Linear Wipe-0002',
                  ix: 2,
                  v: {
                    a: 0,
                    k: -181,
                    ix: 2
                  }
                },
                {
                  ty: 0,
                  nm: 'Feather',
                  mn: 'ADBE Linear Wipe-0003',
                  ix: 3,
                  v: {
                    a: 0,
                    k: 14,
                    ix: 3
                  }
                }
              ]
            },
            {
              ty: 5,
              nm: 'Scale - Overshoot',
              np: 3,
              mn: 'ADBE Slider Control',
              ix: 2,
              en: 1,
              ef: [
                {
                  ty: 0,
                  nm: 'Slider',
                  mn: 'ADBE Slider Control-0001',
                  ix: 1,
                  v: {
                    a: 0,
                    k: 20,
                    ix: 1,
                    x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
                  }
                }
              ]
            },
            {
              ty: 5,
              nm: 'Scale - Bounce',
              np: 3,
              mn: 'ADBE Slider Control',
              ix: 3,
              en: 1,
              ef: [
                {
                  ty: 0,
                  nm: 'Slider',
                  mn: 'ADBE Slider Control-0001',
                  ix: 1,
                  v: {
                    a: 0,
                    k: 40,
                    ix: 1,
                    x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
                  }
                }
              ]
            },
            {
              ty: 5,
              nm: 'Scale - Friction',
              np: 3,
              mn: 'ADBE Slider Control',
              ix: 4,
              en: 1,
              ef: [
                {
                  ty: 0,
                  nm: 'Slider',
                  mn: 'ADBE Slider Control-0001',
                  ix: 1,
                  v: {
                    a: 0,
                    k: 40,
                    ix: 1,
                    x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
                  }
                }
              ]
            },
            {
              ty: 5,
              nm: 'Scale - Overshoot',
              np: 3,
              mn: 'ADBE Slider Control',
              ix: 5,
              en: 1,
              ef: [
                {
                  ty: 0,
                  nm: 'Slider',
                  mn: 'ADBE Slider Control-0001',
                  ix: 1,
                  v: {
                    a: 0,
                    k: 20,
                    ix: 1,
                    x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
                  }
                }
              ]
            },
            {
              ty: 5,
              nm: 'Scale - Bounce',
              np: 3,
              mn: 'ADBE Slider Control',
              ix: 6,
              en: 1,
              ef: [
                {
                  ty: 0,
                  nm: 'Slider',
                  mn: 'ADBE Slider Control-0001',
                  ix: 1,
                  v: {
                    a: 0,
                    k: 40,
                    ix: 1,
                    x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
                  }
                }
              ]
            },
            {
              ty: 5,
              nm: 'Scale - Friction',
              np: 3,
              mn: 'ADBE Slider Control',
              ix: 7,
              en: 1,
              ef: [
                {
                  ty: 0,
                  nm: 'Slider',
                  mn: 'ADBE Slider Control-0001',
                  ix: 1,
                  v: {
                    a: 0,
                    k: 40,
                    ix: 1,
                    x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
                  }
                }
              ]
            }
          ],
          shapes: [
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [[0, 0], [0, 0]],
                      o: [[0, 0], [0, 0]],
                      v: [[20.842, 37.757], [-20.843, -37.757]],
                      c: false
                    },
                    ix: 2
                  },
                  nm: 'Path 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false
                },
                {
                  ty: 'st',
                  c: {
                    a: 0,
                    k: [0, 0, 0, 1],
                    ix: 3
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 4
                  },
                  w: {
                    a: 0,
                    k: 6,
                    ix: 5
                  },
                  lc: 2,
                  lj: 1,
                  ml: 4,
                  bm: 0,
                  nm: 'Stroke 1',
                  mn: 'ADBE Vector Graphic - Stroke',
                  hd: false
                },
                {
                  ty: 'tr',
                  p: {
                    a: 0,
                    k: [0, 0],
                    ix: 2
                  },
                  a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                  },
                  s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                  },
                  r: {
                    a: 0,
                    k: 0,
                    ix: 6
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 7
                  },
                  sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                  },
                  sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                  },
                  nm: 'Transform'
                }
              ],
              nm: 'Shape 1',
              np: 3,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: 'ADBE Vector Group',
              hd: false
            }
          ],
          ip: 0,
          op: 336.000013685561,
          st: 0,
          bm: 0
        },
        {
          ddd: 0,
          ind: 3,
          ty: 4,
          nm: 'Shape Layer 1',
          sr: 1,
          ks: {
            o: {
              a: 0,
              k: 100,
              ix: 11
            },
            r: {
              a: 0,
              k: 0,
              ix: 10
            },
            p: {
              a: 0,
              k: [66.5, 128, 0],
              ix: 2
            },
            a: {
              a: 0,
              k: [0, 0, 0],
              ix: 1
            },
            s: {
              a: 1,
              k: [
                {
                  i: {
                    x: [0.833, 0.833, 0.833],
                    y: [0.833, 0.833, 0.833]
                  },
                  o: {
                    x: [0.167, 0.167, 0.167],
                    y: [0.167, 0.167, 0.167]
                  },
                  t: 2,
                  s: [75, 75, 100]
                },
                {
                  t: 40.0000016292334,
                  s: [100, 100, 100]
                }
              ],
              ix: 6,
              x:
                "var $bm_rt;\nvar amp, freq, decay, n, t, v;\ntry {\n    amp = $bm_div(effect('Scale - Overshoot')('ADBE Slider Control-0001'), 2.5), freq = $bm_div(effect('Scale - Bounce')('ADBE Slider Control-0001'), 20), decay = $bm_div(effect('Scale - Friction')('ADBE Slider Control-0001'), 20), n = 0, 0 < numKeys && (n = nearestKey(time).index, key(n).time > time && n--), t = 0 === n ? 0 : $bm_sub(time, key(n).time), $bm_rt = 0 < n ? (v = velocityAtTime($bm_sub(key(n).time, $bm_div(thisComp.frameDuration, 10))), $bm_sum(value, $bm_div($bm_mul($bm_mul($bm_div(v, 100), amp), Math.sin($bm_mul($bm_mul($bm_mul(freq, t), 2), Math.PI))), Math.exp($bm_mul(decay, t))))) : value;\n} catch (e$$4) {\n    $bm_rt = value = value;\n}"
            }
          },
          ao: 0,
          ef: [
            {
              ty: 5,
              nm: 'Linear Wipe',
              np: 5,
              mn: 'ADBE Linear Wipe',
              ix: 1,
              en: 1,
              ef: [
                {
                  ty: 0,
                  nm: 'Transition Completion',
                  mn: 'ADBE Linear Wipe-0001',
                  ix: 1,
                  v: {
                    a: 1,
                    k: [
                      {
                        i: {
                          x: [0.833],
                          y: [0.833]
                        },
                        o: {
                          x: [0.167],
                          y: [0.167]
                        },
                        t: 2,
                        s: [100]
                      },
                      {
                        t: 52.0000021180034,
                        s: [0]
                      }
                    ],
                    ix: 1
                  }
                },
                {
                  ty: 0,
                  nm: 'Wipe Angle',
                  mn: 'ADBE Linear Wipe-0002',
                  ix: 2,
                  v: {
                    a: 0,
                    k: 90,
                    ix: 2
                  }
                },
                {
                  ty: 0,
                  nm: 'Feather',
                  mn: 'ADBE Linear Wipe-0003',
                  ix: 3,
                  v: {
                    a: 0,
                    k: 31,
                    ix: 3
                  }
                }
              ]
            },
            {
              ty: 5,
              nm: 'Scale - Overshoot',
              np: 3,
              mn: 'ADBE Slider Control',
              ix: 2,
              en: 1,
              ef: [
                {
                  ty: 0,
                  nm: 'Slider',
                  mn: 'ADBE Slider Control-0001',
                  ix: 1,
                  v: {
                    a: 0,
                    k: 20,
                    ix: 1,
                    x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
                  }
                }
              ]
            },
            {
              ty: 5,
              nm: 'Scale - Bounce',
              np: 3,
              mn: 'ADBE Slider Control',
              ix: 3,
              en: 1,
              ef: [
                {
                  ty: 0,
                  nm: 'Slider',
                  mn: 'ADBE Slider Control-0001',
                  ix: 1,
                  v: {
                    a: 0,
                    k: 40,
                    ix: 1,
                    x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
                  }
                }
              ]
            },
            {
              ty: 5,
              nm: 'Scale - Friction',
              np: 3,
              mn: 'ADBE Slider Control',
              ix: 4,
              en: 1,
              ef: [
                {
                  ty: 0,
                  nm: 'Slider',
                  mn: 'ADBE Slider Control-0001',
                  ix: 1,
                  v: {
                    a: 0,
                    k: 40,
                    ix: 1,
                    x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
                  }
                }
              ]
            }
          ],
          shapes: [
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [[0, 0], [0, 0]],
                      o: [[0, 0], [0, 0]],
                      v: [[30.355, 16.208], [-30.355, -16.208]],
                      c: false
                    },
                    ix: 2
                  },
                  nm: 'Path 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false
                },
                {
                  ty: 'st',
                  c: {
                    a: 0,
                    k: [0, 0, 0, 1],
                    ix: 3
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 4
                  },
                  w: {
                    a: 0,
                    k: 6,
                    ix: 5
                  },
                  lc: 2,
                  lj: 1,
                  ml: 4,
                  bm: 0,
                  nm: 'Stroke 1',
                  mn: 'ADBE Vector Graphic - Stroke',
                  hd: false
                },
                {
                  ty: 'tr',
                  p: {
                    a: 0,
                    k: [0, 0],
                    ix: 2
                  },
                  a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                  },
                  s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                  },
                  r: {
                    a: 0,
                    k: 0,
                    ix: 6
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 7
                  },
                  sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                  },
                  sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                  },
                  nm: 'Transform'
                }
              ],
              nm: 'Shape 1',
              np: 3,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: 'ADBE Vector Group',
              hd: false
            }
          ],
          ip: 2.00000008146167,
          op: 420.000017106951,
          st: 2.00000008146167,
          bm: 0
        }
      ]
    },
    {
      id: 'comp_1',
      layers: [
        {
          ddd: 0,
          ind: 1,
          ty: 4,
          nm: 'Shape Layer 4',
          td: 1,
          sr: 1,
          ks: {
            o: {
              a: 0,
              k: 100,
              ix: 11
            },
            r: {
              a: 0,
              k: 0,
              ix: 10
            },
            p: {
              a: 0,
              k: [544, 450, 0],
              ix: 2
            },
            a: {
              a: 0,
              k: [0, 0, 0],
              ix: 1
            },
            s: {
              a: 0,
              k: [100, 100, 100],
              ix: 6
            }
          },
          ao: 0,
          shapes: [
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [[0, 0]],
                      o: [[0, 0]],
                      v: [[739, 641]],
                      c: false
                    },
                    ix: 2
                  },
                  nm: 'Path 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false
                },
                {
                  ty: 'st',
                  c: {
                    a: 0,
                    k: [0.854902020623, 0.886274988511, 0.909803981407, 1],
                    ix: 3
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 4
                  },
                  w: {
                    a: 0,
                    k: 0,
                    ix: 5
                  },
                  lc: 1,
                  lj: 1,
                  ml: 4,
                  bm: 0,
                  nm: 'Stroke 1',
                  mn: 'ADBE Vector Graphic - Stroke',
                  hd: false
                },
                {
                  ty: 'fl',
                  c: {
                    a: 0,
                    k: [0.126149390726, 0.385107362037, 0.579319852941, 1],
                    ix: 4
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 5
                  },
                  r: 1,
                  bm: 0,
                  nm: 'Fill 1',
                  mn: 'ADBE Vector Graphic - Fill',
                  hd: false
                },
                {
                  ty: 'tr',
                  p: {
                    a: 0,
                    k: [0, 0],
                    ix: 2
                  },
                  a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                  },
                  s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                  },
                  r: {
                    a: 0,
                    k: 0,
                    ix: 6
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 7
                  },
                  sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                  },
                  sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                  },
                  nm: 'Transform'
                }
              ],
              nm: 'Shape 2',
              np: 3,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: 'ADBE Vector Group',
              hd: false
            },
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [[0, 0], [0, 0], [0, 0], [0, 0]],
                      o: [[0, 0], [0, 0], [0, 0], [0, 0]],
                      v: [[-187, -55.5], [-507, 645], [490, 646], [172.25, -2]],
                      c: true
                    },
                    ix: 2
                  },
                  nm: 'Path 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false
                },
                {
                  ty: 'st',
                  c: {
                    a: 0,
                    k: [0.854902020623, 0.886274988511, 0.909803981407, 1],
                    ix: 3
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 4
                  },
                  w: {
                    a: 0,
                    k: 0,
                    ix: 5
                  },
                  lc: 1,
                  lj: 1,
                  ml: 4,
                  bm: 0,
                  nm: 'Stroke 1',
                  mn: 'ADBE Vector Graphic - Stroke',
                  hd: false
                },
                {
                  ty: 'fl',
                  c: {
                    a: 0,
                    k: [0.126149390726, 0.385107362037, 0.579319852941, 1],
                    ix: 4
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 5
                  },
                  r: 1,
                  bm: 0,
                  nm: 'Fill 1',
                  mn: 'ADBE Vector Graphic - Fill',
                  hd: false
                },
                {
                  ty: 'tr',
                  p: {
                    a: 0,
                    k: [0, 0],
                    ix: 2
                  },
                  a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                  },
                  s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                  },
                  r: {
                    a: 0,
                    k: 0,
                    ix: 6
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 7
                  },
                  sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                  },
                  sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                  },
                  nm: 'Transform'
                }
              ],
              nm: 'Shape 1',
              np: 3,
              cix: 2,
              bm: 0,
              ix: 2,
              mn: 'ADBE Vector Group',
              hd: false
            }
          ],
          ip: 0,
          op: 206.000008390552,
          st: 0,
          bm: 0
        },
        {
          ddd: 1,
          ind: 2,
          ty: 0,
          nm: 'Ticket',
          tt: 1,
          refId: 'comp_2',
          sr: 1,
          ks: {
            o: {
              a: 0,
              k: 100,
              ix: 11
            },
            rx: {
              a: 0,
              k: 0,
              ix: 8
            },
            ry: {
              a: 0,
              k: 27,
              ix: 9
            },
            rz: {
              a: 0,
              k: 8,
              ix: 10
            },
            or: {
              a: 0,
              k: [0, 0, 0],
              ix: 7
            },
            p: {
              a: 1,
              k: [
                {
                  i: {
                    x: 0.833,
                    y: 0.833
                  },
                  o: {
                    x: 0.167,
                    y: 0.167
                  },
                  t: 169,
                  s: [576.687, -46.765, 0],
                  to: [0, 5.544, 0],
                  ti: [23.342, -278.749, 0]
                },
                {
                  i: {
                    x: 0.833,
                    y: 0.833
                  },
                  o: {
                    x: 0.167,
                    y: 0.167
                  },
                  t: 206,
                  s: [535.422, 453.489, 0],
                  to: [-4.724, 56.418, 0],
                  ti: [5.065, -60.338, 0]
                },
                {
                  i: {
                    x: 0.833,
                    y: 0.833
                  },
                  o: {
                    x: 0.167,
                    y: 0.167
                  },
                  t: 219,
                  s: [520.687, 629.235, 0],
                  to: [-4.91, 58.5, 0],
                  ti: [6.504, -100.885, 0]
                },
                {
                  i: {
                    x: 0.833,
                    y: 0.833
                  },
                  o: {
                    x: 0.167,
                    y: 0.167
                  },
                  t: 242,
                  s: [495.094, 877.523, 0],
                  to: [-17.327, 268.773, 0],
                  ti: [4.111, -90.499, 0]
                },
                {
                  t: 308.000012545097,
                  s: [462.02, 1590.611, 0]
                }
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [540, 540, 0],
              ix: 1
            },
            s: {
              a: 0,
              k: [100, 100, 100],
              ix: 6
            }
          },
          ao: 0,
          w: 1080,
          h: 1080,
          ip: 142.000005783779,
          op: 206.000008390552,
          st: 105.000004276738,
          bm: 0
        },
        {
          ddd: 0,
          ind: 3,
          ty: 4,
          nm: 'Shape Layer 3',
          td: 1,
          sr: 1,
          ks: {
            o: {
              a: 0,
              k: 100,
              ix: 11
            },
            r: {
              a: 0,
              k: 0,
              ix: 10
            },
            p: {
              a: 0,
              k: [544, 450, 0],
              ix: 2
            },
            a: {
              a: 0,
              k: [0, 0, 0],
              ix: 1
            },
            s: {
              a: 0,
              k: [100, 100, 100],
              ix: 6
            }
          },
          ao: 0,
          shapes: [
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [[0, 0]],
                      o: [[0, 0]],
                      v: [[739, 641]],
                      c: false
                    },
                    ix: 2
                  },
                  nm: 'Path 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false
                },
                {
                  ty: 'st',
                  c: {
                    a: 0,
                    k: [0.854902020623, 0.886274988511, 0.909803981407, 1],
                    ix: 3
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 4
                  },
                  w: {
                    a: 0,
                    k: 0,
                    ix: 5
                  },
                  lc: 1,
                  lj: 1,
                  ml: 4,
                  bm: 0,
                  nm: 'Stroke 1',
                  mn: 'ADBE Vector Graphic - Stroke',
                  hd: false
                },
                {
                  ty: 'fl',
                  c: {
                    a: 0,
                    k: [0.126149390726, 0.385107362037, 0.579319852941, 1],
                    ix: 4
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 5
                  },
                  r: 1,
                  bm: 0,
                  nm: 'Fill 1',
                  mn: 'ADBE Vector Graphic - Fill',
                  hd: false
                },
                {
                  ty: 'tr',
                  p: {
                    a: 0,
                    k: [0, 0],
                    ix: 2
                  },
                  a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                  },
                  s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                  },
                  r: {
                    a: 0,
                    k: 0,
                    ix: 6
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 7
                  },
                  sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                  },
                  sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                  },
                  nm: 'Transform'
                }
              ],
              nm: 'Shape 2',
              np: 3,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: 'ADBE Vector Group',
              hd: false
            },
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [[0, 0], [0, 0], [0, 0], [0, 0]],
                      o: [[0, 0], [0, 0], [0, 0], [0, 0]],
                      v: [[-187, -55.5], [-507, 645], [490, 646], [172.25, -2]],
                      c: true
                    },
                    ix: 2
                  },
                  nm: 'Path 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false
                },
                {
                  ty: 'st',
                  c: {
                    a: 0,
                    k: [0.854902020623, 0.886274988511, 0.909803981407, 1],
                    ix: 3
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 4
                  },
                  w: {
                    a: 0,
                    k: 0,
                    ix: 5
                  },
                  lc: 1,
                  lj: 1,
                  ml: 4,
                  bm: 0,
                  nm: 'Stroke 1',
                  mn: 'ADBE Vector Graphic - Stroke',
                  hd: false
                },
                {
                  ty: 'fl',
                  c: {
                    a: 0,
                    k: [0.126149390726, 0.385107362037, 0.579319852941, 1],
                    ix: 4
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 5
                  },
                  r: 1,
                  bm: 0,
                  nm: 'Fill 1',
                  mn: 'ADBE Vector Graphic - Fill',
                  hd: false
                },
                {
                  ty: 'tr',
                  p: {
                    a: 0,
                    k: [0, 0],
                    ix: 2
                  },
                  a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                  },
                  s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                  },
                  r: {
                    a: 0,
                    k: 0,
                    ix: 6
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 7
                  },
                  sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                  },
                  sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                  },
                  nm: 'Transform'
                }
              ],
              nm: 'Shape 1',
              np: 3,
              cix: 2,
              bm: 0,
              ix: 2,
              mn: 'ADBE Vector Group',
              hd: false
            }
          ],
          ip: 0,
          op: 206.000008390552,
          st: 0,
          bm: 0
        },
        {
          ddd: 1,
          ind: 4,
          ty: 0,
          nm: 'Ticket',
          tt: 1,
          refId: 'comp_2',
          sr: 1,
          ks: {
            o: {
              a: 0,
              k: 100,
              ix: 11
            },
            rx: {
              a: 0,
              k: 0,
              ix: 8
            },
            ry: {
              a: 0,
              k: 27,
              ix: 9
            },
            rz: {
              a: 0,
              k: 8,
              ix: 10
            },
            or: {
              a: 0,
              k: [0, 0, 0],
              ix: 7
            },
            p: {
              a: 1,
              k: [
                {
                  i: {
                    x: 0.833,
                    y: 0.833
                  },
                  o: {
                    x: 0.167,
                    y: 0.167
                  },
                  t: 64,
                  s: [576.687, -46.765, 0],
                  to: [0, 6.667, 0],
                  ti: [30.088, -358.456, 0]
                },
                {
                  i: {
                    x: 0.833,
                    y: 0.833
                  },
                  o: {
                    x: 0.167,
                    y: 0.167
                  },
                  t: 114,
                  s: [520.687, 629.235, 0],
                  to: [-4.91, 58.5, 0],
                  ti: [6.504, -100.885, 0]
                },
                {
                  i: {
                    x: 0.833,
                    y: 0.833
                  },
                  o: {
                    x: 0.167,
                    y: 0.167
                  },
                  t: 137,
                  s: [495.094, 877.523, 0],
                  to: [-17.327, 268.773, 0],
                  ti: [4.111, -90.499, 0]
                },
                {
                  t: 203.000008268359,
                  s: [462.02, 1590.611, 0]
                }
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [540, 540, 0],
              ix: 1
            },
            s: {
              a: 0,
              k: [100, 100, 100],
              ix: 6
            }
          },
          ao: 0,
          w: 1080,
          h: 1080,
          ip: 63.0000025660426,
          op: 206.000008390552,
          st: 0,
          bm: 0
        },
        {
          ddd: 0,
          ind: 5,
          ty: 4,
          nm: 'Shape Layer 2',
          td: 1,
          sr: 1,
          ks: {
            o: {
              a: 0,
              k: 100,
              ix: 11
            },
            r: {
              a: 0,
              k: 0,
              ix: 10
            },
            p: {
              a: 0,
              k: [544, 450, 0],
              ix: 2
            },
            a: {
              a: 0,
              k: [0, 0, 0],
              ix: 1
            },
            s: {
              a: 0,
              k: [100, 100, 100],
              ix: 6
            }
          },
          ao: 0,
          shapes: [
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [[0, 0]],
                      o: [[0, 0]],
                      v: [[739, 641]],
                      c: false
                    },
                    ix: 2
                  },
                  nm: 'Path 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false
                },
                {
                  ty: 'st',
                  c: {
                    a: 0,
                    k: [0.854902020623, 0.886274988511, 0.909803981407, 1],
                    ix: 3
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 4
                  },
                  w: {
                    a: 0,
                    k: 0,
                    ix: 5
                  },
                  lc: 1,
                  lj: 1,
                  ml: 4,
                  bm: 0,
                  nm: 'Stroke 1',
                  mn: 'ADBE Vector Graphic - Stroke',
                  hd: false
                },
                {
                  ty: 'fl',
                  c: {
                    a: 0,
                    k: [0.126149390726, 0.385107362037, 0.579319852941, 1],
                    ix: 4
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 5
                  },
                  r: 1,
                  bm: 0,
                  nm: 'Fill 1',
                  mn: 'ADBE Vector Graphic - Fill',
                  hd: false
                },
                {
                  ty: 'tr',
                  p: {
                    a: 0,
                    k: [0, 0],
                    ix: 2
                  },
                  a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                  },
                  s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                  },
                  r: {
                    a: 0,
                    k: 0,
                    ix: 6
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 7
                  },
                  sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                  },
                  sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                  },
                  nm: 'Transform'
                }
              ],
              nm: 'Shape 2',
              np: 3,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: 'ADBE Vector Group',
              hd: false
            },
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [[0, 0], [0, 0], [0, 0], [0, 0]],
                      o: [[0, 0], [0, 0], [0, 0], [0, 0]],
                      v: [[-187, -55.5], [-507, 645], [490, 646], [172.25, -2]],
                      c: true
                    },
                    ix: 2
                  },
                  nm: 'Path 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false
                },
                {
                  ty: 'st',
                  c: {
                    a: 0,
                    k: [0.854902020623, 0.886274988511, 0.909803981407, 1],
                    ix: 3
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 4
                  },
                  w: {
                    a: 0,
                    k: 0,
                    ix: 5
                  },
                  lc: 1,
                  lj: 1,
                  ml: 4,
                  bm: 0,
                  nm: 'Stroke 1',
                  mn: 'ADBE Vector Graphic - Stroke',
                  hd: false
                },
                {
                  ty: 'fl',
                  c: {
                    a: 0,
                    k: [0.126149390726, 0.385107362037, 0.579319852941, 1],
                    ix: 4
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 5
                  },
                  r: 1,
                  bm: 0,
                  nm: 'Fill 1',
                  mn: 'ADBE Vector Graphic - Fill',
                  hd: false
                },
                {
                  ty: 'tr',
                  p: {
                    a: 0,
                    k: [0, 0],
                    ix: 2
                  },
                  a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                  },
                  s: {
                    a: 0,
                    k: [100, 100],
                    ix: 3
                  },
                  r: {
                    a: 0,
                    k: 0,
                    ix: 6
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 7
                  },
                  sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                  },
                  sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                  },
                  nm: 'Transform'
                }
              ],
              nm: 'Shape 1',
              np: 3,
              cix: 2,
              bm: 0,
              ix: 2,
              mn: 'ADBE Vector Group',
              hd: false
            }
          ],
          ip: 0,
          op: 206.000008390552,
          st: 0,
          bm: 0
        },
        {
          ddd: 1,
          ind: 6,
          ty: 0,
          nm: 'Ticket',
          tt: 1,
          refId: 'comp_2',
          sr: 1,
          ks: {
            o: {
              a: 0,
              k: 100,
              ix: 11
            },
            rx: {
              a: 0,
              k: 0,
              ix: 8
            },
            ry: {
              a: 0,
              k: 27,
              ix: 9
            },
            rz: {
              a: 0,
              k: 8,
              ix: 10
            },
            or: {
              a: 0,
              k: [0, 0, 0],
              ix: 7
            },
            p: {
              a: 1,
              k: [
                {
                  i: {
                    x: 0.833,
                    y: 0.833
                  },
                  o: {
                    x: 0.167,
                    y: 0.167
                  },
                  t: -37,
                  s: [576.687, -46.765, 0],
                  to: [0, 6.667, 0],
                  ti: [30.088, -358.456, 0]
                },
                {
                  i: {
                    x: 0.833,
                    y: 0.833
                  },
                  o: {
                    x: 0.167,
                    y: 0.167
                  },
                  t: 13,
                  s: [520.687, 629.235, 0],
                  to: [-4.91, 58.5, 0],
                  ti: [6.504, -100.885, 0]
                },
                {
                  i: {
                    x: 0.833,
                    y: 0.833
                  },
                  o: {
                    x: 0.167,
                    y: 0.167
                  },
                  t: 36,
                  s: [495.094, 877.523, 0],
                  to: [-17.327, 268.773, 0],
                  ti: [4.111, -90.499, 0]
                },
                {
                  t: 102.000004154545,
                  s: [462.02, 1590.611, 0]
                }
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [540, 540, 0],
              ix: 1
            },
            s: {
              a: 0,
              k: [100, 100, 100],
              ix: 6
            }
          },
          ao: 0,
          w: 1080,
          h: 1080,
          ip: 0,
          op: 206.000008390552,
          st: -101.000004113814,
          bm: 0
        },
        {
          ddd: 0,
          ind: 7,
          ty: 2,
          nm: 'Artwork 4',
          refId: 'image_1',
          sr: 1,
          ks: {
            o: {
              a: 0,
              k: 100,
              ix: 11
            },
            r: {
              a: 0,
              k: 0,
              ix: 10
            },
            p: {
              a: 0,
              k: [541, 426, 0],
              ix: 2
            },
            a: {
              a: 0,
              k: [231.5, 97.5, 0],
              ix: 1
            },
            s: {
              a: 0,
              k: [100, 100, 100],
              ix: 6
            }
          },
          ao: 0,
          ip: 0,
          op: 206.000008390552,
          st: 0,
          bm: 0
        },
        {
          ddd: 0,
          ind: 8,
          ty: 4,
          nm: 'Shape Layer 1',
          sr: 1,
          ks: {
            o: {
              a: 0,
              k: 100,
              ix: 11
            },
            r: {
              a: 0,
              k: 0,
              ix: 10
            },
            p: {
              a: 0,
              k: [536.149, 482, 0],
              ix: 2
            },
            a: {
              a: 0,
              k: [0, 0, 0],
              ix: 1
            },
            s: {
              a: 0,
              k: [97.897, 97.897, 100],
              ix: 6
            }
          },
          ao: 0,
          shapes: [
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [[131.122, 0], [0, -131.122], [-131.122, 0], [0, 131.122]],
                      o: [[-131.122, 0], [0, 131.122], [131.122, 0], [0, -131.122]],
                      v: [[0, -237.418], [-237.418, 0], [0, 237.418], [237.418, 0]],
                      c: true
                    },
                    ix: 2
                  },
                  nm: 'Path 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false
                },
                {
                  ty: 'st',
                  c: {
                    a: 0,
                    k: [1, 1, 1, 1],
                    ix: 3
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 4
                  },
                  w: {
                    a: 0,
                    k: 0,
                    ix: 5
                  },
                  lc: 1,
                  lj: 1,
                  ml: 4,
                  bm: 0,
                  nm: 'Stroke 1',
                  mn: 'ADBE Vector Graphic - Stroke',
                  hd: false
                },
                {
                  ty: 'fl',
                  c: {
                    a: 0,
                    k: [0.854901960784, 0.886274509804, 0.909803921569, 1],
                    ix: 4
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 5
                  },
                  r: 1,
                  bm: 0,
                  nm: 'Fill 1',
                  mn: 'ADBE Vector Graphic - Fill',
                  hd: false
                },
                {
                  ty: 'tr',
                  p: {
                    a: 0,
                    k: [3.934, -3.277],
                    ix: 2
                  },
                  a: {
                    a: 0,
                    k: [0, 0],
                    ix: 1
                  },
                  s: {
                    a: 0,
                    k: [159.393, 159.393],
                    ix: 3
                  },
                  r: {
                    a: 0,
                    k: 0,
                    ix: 6
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 7
                  },
                  sk: {
                    a: 0,
                    k: 0,
                    ix: 4
                  },
                  sa: {
                    a: 0,
                    k: 0,
                    ix: 5
                  },
                  nm: 'Transform'
                }
              ],
              nm: 'Ellipse 1',
              np: 3,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: 'ADBE Vector Group',
              hd: false
            }
          ],
          ip: 0,
          op: 206.000008390552,
          st: 0,
          bm: 0
        }
      ]
    },
    {
      id: 'comp_2',
      layers: [
        {
          ddd: 0,
          ind: 1,
          ty: 2,
          nm: 'KIS_Ticket-31.png',
          cl: 'png',
          refId: 'image_0',
          sr: 1,
          ks: {
            o: {
              a: 0,
              k: 100,
              ix: 11
            },
            r: {
              a: 0,
              k: 0,
              ix: 10
            },
            p: {
              a: 0,
              k: [526, 538, 0],
              ix: 2
            },
            a: {
              a: 0,
              k: [744.5, 1268.5, 0],
              ix: 1
            },
            s: {
              a: 0,
              k: [48, 48, 100],
              ix: 6
            }
          },
          ao: 0,
          ef: [
            {
              ty: 5,
              nm: 'Wave Warp',
              np: 10,
              mn: 'ADBE Wave Warp',
              ix: 1,
              en: 1,
              ef: [
                {
                  ty: 7,
                  nm: 'Wave Type',
                  mn: 'ADBE Wave Warp-0001',
                  ix: 1,
                  v: {
                    a: 0,
                    k: 1,
                    ix: 1
                  }
                },
                {
                  ty: 0,
                  nm: 'Wave Height',
                  mn: 'ADBE Wave Warp-0002',
                  ix: 2,
                  v: {
                    a: 0,
                    k: 40,
                    ix: 2
                  }
                },
                {
                  ty: 0,
                  nm: 'Wave Width',
                  mn: 'ADBE Wave Warp-0003',
                  ix: 3,
                  v: {
                    a: 0,
                    k: 862.4,
                    ix: 3
                  }
                },
                {
                  ty: 0,
                  nm: 'Direction',
                  mn: 'ADBE Wave Warp-0004',
                  ix: 4,
                  v: {
                    a: 0,
                    k: 0,
                    ix: 4
                  }
                },
                {
                  ty: 7,
                  nm: 'Wave Speed',
                  mn: 'ADBE Wave Warp-0005',
                  ix: 5,
                  v: {
                    a: 0,
                    k: 0.7,
                    ix: 5
                  }
                },
                {
                  ty: 7,
                  nm: 'Pinning',
                  mn: 'ADBE Wave Warp-0006',
                  ix: 6,
                  v: {
                    a: 0,
                    k: 1,
                    ix: 6
                  }
                },
                {
                  ty: 0,
                  nm: 'Phase',
                  mn: 'ADBE Wave Warp-0007',
                  ix: 7,
                  v: {
                    a: 0,
                    k: 0,
                    ix: 7
                  }
                },
                {
                  ty: 7,
                  nm: 'Antialiasing (Best Quality)',
                  mn: 'ADBE Wave Warp-0008',
                  ix: 8,
                  v: {
                    a: 0,
                    k: 3,
                    ix: 8
                  }
                }
              ]
            }
          ],
          ip: 0,
          op: 1500.00006109625,
          st: 0,
          bm: 0
        }
      ]
    }
  ],
  layers: [
    {
      ddd: 0,
      ind: 1,
      ty: 0,
      nm: 'Line Bursts',
      refId: 'comp_0',
      sr: 0.5,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: {
                x: [0.833],
                y: [0.833]
              },
              o: {
                x: [0.34],
                y: [0]
              },
              t: 120,
              s: [100]
            },
            {
              t: 140.000005702317,
              s: [0]
            }
          ],
          ix: 11
        },
        r: {
          a: 0,
          k: 140,
          ix: 10
        },
        p: {
          a: 0,
          k: [844, 504, 0],
          ix: 2,
          x:
            "var $bm_rt;\nvar amp, freq, decay, n, t, v;\ntry {\n    amp = $bm_div(effect('Position - Overshoot')('ADBE Slider Control-0001'), 2.5), freq = $bm_div(effect('Position - Bounce')('ADBE Slider Control-0001'), 20), decay = $bm_div(effect('Position - Friction')('ADBE Slider Control-0001'), 20), n = 0, 0 < numKeys && (n = nearestKey(time).index, key(n).time > time && n--), t = 0 === n ? 0 : $bm_sub(time, key(n).time), $bm_rt = 0 < n ? (v = velocityAtTime($bm_sub(key(n).time, $bm_div(thisComp.frameDuration, 10))), $bm_sum(value, $bm_div($bm_mul($bm_mul($bm_div(v, 100), amp), Math.sin($bm_mul($bm_mul($bm_mul(freq, t), 2), Math.PI))), Math.exp($bm_mul(decay, t))))) : value;\n} catch (e$$4) {\n    $bm_rt = value = value;\n}"
        },
        a: {
          a: 0,
          k: [106.5, 100, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100, 100],
          ix: 6,
          x:
            "var $bm_rt;\nvar amp, freq, decay, n, t, v;\ntry {\n    amp = $bm_div(effect('Scale - Overshoot')('ADBE Slider Control-0001'), 2.5), freq = $bm_div(effect('Scale - Bounce')('ADBE Slider Control-0001'), 20), decay = $bm_div(effect('Scale - Friction')('ADBE Slider Control-0001'), 20), n = 0, 0 < numKeys && (n = nearestKey(time).index, key(n).time > time && n--), t = 0 === n ? 0 : $bm_sub(time, key(n).time), $bm_rt = 0 < n ? (v = velocityAtTime($bm_sub(key(n).time, $bm_div(thisComp.frameDuration, 10))), $bm_sum(value, $bm_div($bm_mul($bm_mul($bm_div(v, 100), amp), Math.sin($bm_mul($bm_mul($bm_mul(freq, t), 2), Math.PI))), Math.exp($bm_mul(decay, t))))) : value;\n} catch (e$$4) {\n    $bm_rt = value = value;\n}"
        }
      },
      ao: 0,
      ef: [
        {
          ty: 5,
          nm: 'Scale - Overshoot',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 1,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 20,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        },
        {
          ty: 5,
          nm: 'Scale - Bounce',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 2,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 40,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        },
        {
          ty: 5,
          nm: 'Scale - Friction',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 3,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 40,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        },
        {
          ty: 5,
          nm: 'Position - Overshoot',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 4,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 20,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        },
        {
          ty: 5,
          nm: 'Position - Bounce',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 5,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 40,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        },
        {
          ty: 5,
          nm: 'Position - Friction',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 6,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 40,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        },
        {
          ty: 5,
          nm: 'Scale - Overshoot',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 7,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 20,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        },
        {
          ty: 5,
          nm: 'Scale - Bounce',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 8,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 40,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        },
        {
          ty: 5,
          nm: 'Scale - Friction',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 9,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 40,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        },
        {
          ty: 5,
          nm: 'Position - Overshoot',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 10,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 20,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        },
        {
          ty: 5,
          nm: 'Position - Bounce',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 11,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 40,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        },
        {
          ty: 5,
          nm: 'Position - Friction',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 12,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 40,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        },
        {
          ty: 5,
          nm: 'Scale - Overshoot',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 13,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 20,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        },
        {
          ty: 5,
          nm: 'Scale - Bounce',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 14,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 40,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        },
        {
          ty: 5,
          nm: 'Scale - Friction',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 15,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 40,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        },
        {
          ty: 5,
          nm: 'Scale - Overshoot',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 16,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 20,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        },
        {
          ty: 5,
          nm: 'Scale - Bounce',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 17,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 40,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        },
        {
          ty: 5,
          nm: 'Scale - Friction',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 18,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 40,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        }
      ],
      w: 213,
      h: 200,
      ip: 90.0000036657751,
      op: 240.0000097754,
      st: 90.0000036657751,
      bm: 0
    },
    {
      ddd: 0,
      ind: 2,
      ty: 0,
      nm: 'Line Bursts',
      refId: 'comp_0',
      sr: 0.5,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: {
                x: [0.833],
                y: [0.833]
              },
              o: {
                x: [0.34],
                y: [0]
              },
              t: 120,
              s: [100]
            },
            {
              t: 140.000005702317,
              s: [0]
            }
          ],
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [308, 266, 0],
          ix: 2,
          x:
            "var $bm_rt;\nvar amp, freq, decay, n, t, v;\ntry {\n    amp = $bm_div(effect('Position - Overshoot')('ADBE Slider Control-0001'), 2.5), freq = $bm_div(effect('Position - Bounce')('ADBE Slider Control-0001'), 20), decay = $bm_div(effect('Position - Friction')('ADBE Slider Control-0001'), 20), n = 0, 0 < numKeys && (n = nearestKey(time).index, key(n).time > time && n--), t = 0 === n ? 0 : $bm_sub(time, key(n).time), $bm_rt = 0 < n ? (v = velocityAtTime($bm_sub(key(n).time, $bm_div(thisComp.frameDuration, 10))), $bm_sum(value, $bm_div($bm_mul($bm_mul($bm_div(v, 100), amp), Math.sin($bm_mul($bm_mul($bm_mul(freq, t), 2), Math.PI))), Math.exp($bm_mul(decay, t))))) : value;\n} catch (e$$4) {\n    $bm_rt = value = value;\n}"
        },
        a: {
          a: 0,
          k: [106.5, 100, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100, 100],
          ix: 6,
          x:
            "var $bm_rt;\nvar amp, freq, decay, n, t, v;\ntry {\n    amp = $bm_div(effect('Scale - Overshoot')('ADBE Slider Control-0001'), 2.5), freq = $bm_div(effect('Scale - Bounce')('ADBE Slider Control-0001'), 20), decay = $bm_div(effect('Scale - Friction')('ADBE Slider Control-0001'), 20), n = 0, 0 < numKeys && (n = nearestKey(time).index, key(n).time > time && n--), t = 0 === n ? 0 : $bm_sub(time, key(n).time), $bm_rt = 0 < n ? (v = velocityAtTime($bm_sub(key(n).time, $bm_div(thisComp.frameDuration, 10))), $bm_sum(value, $bm_div($bm_mul($bm_mul($bm_div(v, 100), amp), Math.sin($bm_mul($bm_mul($bm_mul(freq, t), 2), Math.PI))), Math.exp($bm_mul(decay, t))))) : value;\n} catch (e$$4) {\n    $bm_rt = value = value;\n}"
        }
      },
      ao: 0,
      ef: [
        {
          ty: 5,
          nm: 'Scale - Overshoot',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 1,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 20,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        },
        {
          ty: 5,
          nm: 'Scale - Bounce',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 2,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 40,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        },
        {
          ty: 5,
          nm: 'Scale - Friction',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 3,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 40,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        },
        {
          ty: 5,
          nm: 'Position - Overshoot',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 4,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 20,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        },
        {
          ty: 5,
          nm: 'Position - Bounce',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 5,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 40,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        },
        {
          ty: 5,
          nm: 'Position - Friction',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 6,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 40,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        },
        {
          ty: 5,
          nm: 'Scale - Overshoot',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 7,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 20,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        },
        {
          ty: 5,
          nm: 'Scale - Bounce',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 8,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 40,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        },
        {
          ty: 5,
          nm: 'Scale - Friction',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 9,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 40,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        },
        {
          ty: 5,
          nm: 'Position - Overshoot',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 10,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 20,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        },
        {
          ty: 5,
          nm: 'Position - Bounce',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 11,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 40,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        },
        {
          ty: 5,
          nm: 'Position - Friction',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 12,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 40,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        },
        {
          ty: 5,
          nm: 'Scale - Overshoot',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 13,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 20,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        },
        {
          ty: 5,
          nm: 'Scale - Bounce',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 14,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 40,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        },
        {
          ty: 5,
          nm: 'Scale - Friction',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 15,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 40,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        },
        {
          ty: 5,
          nm: 'Scale - Overshoot',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 16,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 20,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        },
        {
          ty: 5,
          nm: 'Scale - Bounce',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 17,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 40,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        },
        {
          ty: 5,
          nm: 'Scale - Friction',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 18,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 40,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        }
      ],
      w: 213,
      h: 200,
      ip: 90.0000036657751,
      op: 240.0000097754,
      st: 90.0000036657751,
      bm: 0
    },
    {
      ddd: 0,
      ind: 3,
      ty: 0,
      nm: 'Line Bursts',
      refId: 'comp_0',
      sr: 0.5,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: {
                x: [0.833],
                y: [0.833]
              },
              o: {
                x: [0.34],
                y: [0]
              },
              t: 30,
              s: [100]
            },
            {
              t: 50.0000020365418,
              s: [0]
            }
          ],
          ix: 11
        },
        r: {
          a: 0,
          k: 140,
          ix: 10
        },
        p: {
          a: 0,
          k: [844, 504, 0],
          ix: 2,
          x:
            "var $bm_rt;\nvar amp, freq, decay, n, t, v;\ntry {\n    amp = $bm_div(effect('Position - Overshoot')('ADBE Slider Control-0001'), 2.5), freq = $bm_div(effect('Position - Bounce')('ADBE Slider Control-0001'), 20), decay = $bm_div(effect('Position - Friction')('ADBE Slider Control-0001'), 20), n = 0, 0 < numKeys && (n = nearestKey(time).index, key(n).time > time && n--), t = 0 === n ? 0 : $bm_sub(time, key(n).time), $bm_rt = 0 < n ? (v = velocityAtTime($bm_sub(key(n).time, $bm_div(thisComp.frameDuration, 10))), $bm_sum(value, $bm_div($bm_mul($bm_mul($bm_div(v, 100), amp), Math.sin($bm_mul($bm_mul($bm_mul(freq, t), 2), Math.PI))), Math.exp($bm_mul(decay, t))))) : value;\n} catch (e$$4) {\n    $bm_rt = value = value;\n}"
        },
        a: {
          a: 0,
          k: [106.5, 100, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100, 100],
          ix: 6,
          x:
            "var $bm_rt;\nvar amp, freq, decay, n, t, v;\ntry {\n    amp = $bm_div(effect('Scale - Overshoot')('ADBE Slider Control-0001'), 2.5), freq = $bm_div(effect('Scale - Bounce')('ADBE Slider Control-0001'), 20), decay = $bm_div(effect('Scale - Friction')('ADBE Slider Control-0001'), 20), n = 0, 0 < numKeys && (n = nearestKey(time).index, key(n).time > time && n--), t = 0 === n ? 0 : $bm_sub(time, key(n).time), $bm_rt = 0 < n ? (v = velocityAtTime($bm_sub(key(n).time, $bm_div(thisComp.frameDuration, 10))), $bm_sum(value, $bm_div($bm_mul($bm_mul($bm_div(v, 100), amp), Math.sin($bm_mul($bm_mul($bm_mul(freq, t), 2), Math.PI))), Math.exp($bm_mul(decay, t))))) : value;\n} catch (e$$4) {\n    $bm_rt = value = value;\n}"
        }
      },
      ao: 0,
      ef: [
        {
          ty: 5,
          nm: 'Scale - Overshoot',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 1,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 20,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        },
        {
          ty: 5,
          nm: 'Scale - Bounce',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 2,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 40,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        },
        {
          ty: 5,
          nm: 'Scale - Friction',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 3,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 40,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        },
        {
          ty: 5,
          nm: 'Position - Overshoot',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 4,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 20,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        },
        {
          ty: 5,
          nm: 'Position - Bounce',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 5,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 40,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        },
        {
          ty: 5,
          nm: 'Position - Friction',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 6,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 40,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        },
        {
          ty: 5,
          nm: 'Scale - Overshoot',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 7,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 20,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        },
        {
          ty: 5,
          nm: 'Scale - Bounce',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 8,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 40,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        },
        {
          ty: 5,
          nm: 'Scale - Friction',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 9,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 40,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        },
        {
          ty: 5,
          nm: 'Position - Overshoot',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 10,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 20,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        },
        {
          ty: 5,
          nm: 'Position - Bounce',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 11,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 40,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        },
        {
          ty: 5,
          nm: 'Position - Friction',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 12,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 40,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        },
        {
          ty: 5,
          nm: 'Scale - Overshoot',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 13,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 20,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        },
        {
          ty: 5,
          nm: 'Scale - Bounce',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 14,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 40,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        },
        {
          ty: 5,
          nm: 'Scale - Friction',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 15,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 40,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        },
        {
          ty: 5,
          nm: 'Scale - Overshoot',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 16,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 20,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        },
        {
          ty: 5,
          nm: 'Scale - Bounce',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 17,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 40,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        },
        {
          ty: 5,
          nm: 'Scale - Friction',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 18,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 40,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        }
      ],
      w: 213,
      h: 200,
      ip: 0,
      op: 150.000006109625,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 4,
      ty: 0,
      nm: 'Line Bursts',
      refId: 'comp_0',
      sr: 0.5,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: {
                x: [0.833],
                y: [0.833]
              },
              o: {
                x: [0.34],
                y: [0]
              },
              t: 30,
              s: [100]
            },
            {
              t: 50.0000020365418,
              s: [0]
            }
          ],
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [308, 266, 0],
          ix: 2,
          x:
            "var $bm_rt;\nvar amp, freq, decay, n, t, v;\ntry {\n    amp = $bm_div(effect('Position - Overshoot')('ADBE Slider Control-0001'), 2.5), freq = $bm_div(effect('Position - Bounce')('ADBE Slider Control-0001'), 20), decay = $bm_div(effect('Position - Friction')('ADBE Slider Control-0001'), 20), n = 0, 0 < numKeys && (n = nearestKey(time).index, key(n).time > time && n--), t = 0 === n ? 0 : $bm_sub(time, key(n).time), $bm_rt = 0 < n ? (v = velocityAtTime($bm_sub(key(n).time, $bm_div(thisComp.frameDuration, 10))), $bm_sum(value, $bm_div($bm_mul($bm_mul($bm_div(v, 100), amp), Math.sin($bm_mul($bm_mul($bm_mul(freq, t), 2), Math.PI))), Math.exp($bm_mul(decay, t))))) : value;\n} catch (e$$4) {\n    $bm_rt = value = value;\n}"
        },
        a: {
          a: 0,
          k: [106.5, 100, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100, 100],
          ix: 6,
          x:
            "var $bm_rt;\nvar amp, freq, decay, n, t, v;\ntry {\n    amp = $bm_div(effect('Scale - Overshoot')('ADBE Slider Control-0001'), 2.5), freq = $bm_div(effect('Scale - Bounce')('ADBE Slider Control-0001'), 20), decay = $bm_div(effect('Scale - Friction')('ADBE Slider Control-0001'), 20), n = 0, 0 < numKeys && (n = nearestKey(time).index, key(n).time > time && n--), t = 0 === n ? 0 : $bm_sub(time, key(n).time), $bm_rt = 0 < n ? (v = velocityAtTime($bm_sub(key(n).time, $bm_div(thisComp.frameDuration, 10))), $bm_sum(value, $bm_div($bm_mul($bm_mul($bm_div(v, 100), amp), Math.sin($bm_mul($bm_mul($bm_mul(freq, t), 2), Math.PI))), Math.exp($bm_mul(decay, t))))) : value;\n} catch (e$$4) {\n    $bm_rt = value = value;\n}"
        }
      },
      ao: 0,
      ef: [
        {
          ty: 5,
          nm: 'Scale - Overshoot',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 1,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 20,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        },
        {
          ty: 5,
          nm: 'Scale - Bounce',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 2,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 40,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        },
        {
          ty: 5,
          nm: 'Scale - Friction',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 3,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 40,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        },
        {
          ty: 5,
          nm: 'Position - Overshoot',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 4,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 20,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        },
        {
          ty: 5,
          nm: 'Position - Bounce',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 5,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 40,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        },
        {
          ty: 5,
          nm: 'Position - Friction',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 6,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 40,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        },
        {
          ty: 5,
          nm: 'Scale - Overshoot',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 7,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 20,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        },
        {
          ty: 5,
          nm: 'Scale - Bounce',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 8,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 40,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        },
        {
          ty: 5,
          nm: 'Scale - Friction',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 9,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 40,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        },
        {
          ty: 5,
          nm: 'Position - Overshoot',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 10,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 20,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        },
        {
          ty: 5,
          nm: 'Position - Bounce',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 11,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 40,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        },
        {
          ty: 5,
          nm: 'Position - Friction',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 12,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 40,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        },
        {
          ty: 5,
          nm: 'Scale - Overshoot',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 13,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 20,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        },
        {
          ty: 5,
          nm: 'Scale - Bounce',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 14,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 40,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        },
        {
          ty: 5,
          nm: 'Scale - Friction',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 15,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 40,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        },
        {
          ty: 5,
          nm: 'Scale - Overshoot',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 16,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 20,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        },
        {
          ty: 5,
          nm: 'Scale - Bounce',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 17,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 40,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        },
        {
          ty: 5,
          nm: 'Scale - Friction',
          np: 3,
          mn: 'ADBE Slider Control',
          ix: 18,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Slider',
              mn: 'ADBE Slider Control-0001',
              ix: 1,
              v: {
                a: 0,
                k: 40,
                ix: 1,
                x: 'var $bm_rt;\n$bm_rt = clamp(value, 0, 100);'
              }
            }
          ]
        }
      ],
      w: 213,
      h: 200,
      ip: 0,
      op: 150.000006109625,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 5,
      ty: 4,
      nm: 'Shape Layer 3',
      td: 1,
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [538, 632, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 78.755, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ty: 'rc',
              d: 1,
              s: {
                a: 0,
                k: [1081.75, 1082.461],
                ix: 2
              },
              p: {
                a: 0,
                k: [0, 0],
                ix: 3
              },
              r: {
                a: 0,
                k: 0,
                ix: 4
              },
              nm: 'Rectangle Path 1',
              mn: 'ADBE Vector Shape - Rect',
              hd: false
            },
            {
              ty: 'st',
              c: {
                a: 0,
                k: [0.854902020623, 0.886274988511, 0.909803981407, 1],
                ix: 3
              },
              o: {
                a: 0,
                k: 100,
                ix: 4
              },
              w: {
                a: 0,
                k: 0,
                ix: 5
              },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: 'Stroke 1',
              mn: 'ADBE Vector Graphic - Stroke',
              hd: false
            },
            {
              ty: 'gf',
              o: {
                a: 0,
                k: 100,
                ix: 10
              },
              r: 2,
              bm: 0,
              g: {
                p: 3,
                k: {
                  a: 0,
                  k: [0, 1, 1, 1, 0.5, 0.5, 0.5, 0.5, 1, 0, 0, 0, 0, 0, 0.8, 0.5, 1, 1],
                  ix: 9
                }
              },
              s: {
                a: 0,
                k: [2.109, -516.967],
                ix: 5
              },
              e: {
                a: 0,
                k: [-0.945, 160.549],
                ix: 6
              },
              t: 1,
              nm: 'Gradient Fill 1',
              mn: 'ADBE Vector Graphic - G-Fill',
              hd: false
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [0.875, 447.051],
                ix: 2
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1
              },
              s: {
                a: 0,
                k: [100, 60.439],
                ix: 3
              },
              r: {
                a: 0,
                k: 0,
                ix: 6
              },
              o: {
                a: 0,
                k: 100,
                ix: 7
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5
              },
              nm: 'Transform'
            }
          ],
          nm: 'Rectangle 1',
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [[0, 0]],
                  o: [[0, 0]],
                  v: [[-1260, 92]],
                  c: false
                },
                ix: 2
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false
            },
            {
              ty: 'st',
              c: {
                a: 0,
                k: [0.854902020623, 0.886274988511, 0.909803981407, 1],
                ix: 3
              },
              o: {
                a: 0,
                k: 100,
                ix: 4
              },
              w: {
                a: 0,
                k: 0,
                ix: 5
              },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: 'Stroke 1',
              mn: 'ADBE Vector Graphic - Stroke',
              hd: false
            },
            {
              ty: 'gf',
              o: {
                a: 0,
                k: 100,
                ix: 10
              },
              r: 1,
              bm: 0,
              g: {
                p: 3,
                k: {
                  a: 0,
                  k: [0, 1, 1, 1, 0.5, 0.5, 0.5, 0.5, 1, 0, 0, 0, 0, 0, 0.8, 0.5, 1, 1],
                  ix: 9
                }
              },
              s: {
                a: 0,
                k: [0, 0],
                ix: 5
              },
              e: {
                a: 0,
                k: [100, 0],
                ix: 6
              },
              t: 1,
              nm: 'Gradient Fill 1',
              mn: 'ADBE Vector Graphic - G-Fill',
              hd: false
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [0, 0],
                ix: 2
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3
              },
              r: {
                a: 0,
                k: 0,
                ix: 6
              },
              o: {
                a: 0,
                k: 100,
                ix: 7
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5
              },
              nm: 'Transform'
            }
          ],
          nm: 'Shape 1',
          np: 3,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: 'ADBE Vector Group',
          hd: false
        }
      ],
      ip: 0,
      op: 206.000008390552,
      st: -27.0000010997325,
      bm: 0
    },
    {
      ddd: 0,
      ind: 6,
      ty: 0,
      nm: 'Printing',
      tt: 2,
      refId: 'comp_1',
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [540, 538, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [540, 540, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100, 100],
          ix: 6
        }
      },
      ao: 0,
      w: 1080,
      h: 1080,
      ip: 0,
      op: 206.000008390552,
      st: 0,
      bm: 0
    }
  ],
  markers: []
};
